import { createFileRoute, redirect } from "@tanstack/react-router";

import { AppLayout } from "@/app/shell/AppLayout";
import { meQueryOptions } from "@/shared/auth/me";
import { staffRoleOf } from "@/shared/auth/roles";
import { hasSession } from "@/shared/auth/session";

/**
 * Everything behind the sign-in. The guard answers two questions before any
 * page loads: is somebody signed in, and with which staff role. Child routes
 * read `role` from the context.
 */
export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ context, location }) => {
    const signIn = () => redirect({ to: "/sign-in", search: { redirect: location.href } });
    if (!hasSession()) throw signIn();
    try {
      // "static": the person already known is good enough to decide where to
      // go; the layout's own query keeps them fresh.
      const me = await context.queryClient.query({ ...meQueryOptions, staleTime: "static" });
      return { role: staffRoleOf(me) };
    } catch (error) {
      // The session ended while asking (revoked, refresh refused): not an error to show.
      if (!hasSession()) throw signIn();
      throw error;
    }
  },
  component: AppLayout,
});
